import { useState, useRef ,useEffect} from "react";
import { useRaspStore } from "../store/raspStore.ts";
import { roundsService } from "../services/RoundsService.ts";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode"

// getUserIdFromJWT removed - using LoginContext

export const useRoundsViewModel = (userId: string, appId: string) => {
  const [fields, setFields] = useState<any[]>([]);
  const [foreignKeyData, setForeignKeyData] = useState<any>({});
  const [enums, setEnums] = useState<any>({});
  const [dataToSave, setDataToSave] = useState<any>({});
const [fetchedForeign, setFetchedForeign] = useState<Set<string>>(new Set());
const [fetchedEnum, setFetchedEnum] = useState<Set<string>>(new Set());
  const addSubmission = useRaspStore((s) => s.addSubmission);
  const getSubmissions = useRaspStore((s) => s.getSubmissions);
    const getUserAllData = useRaspStore((s) => s.getUserAllData);
    useEffect(()=>{
      const dataFromStore = getSubmissions(userId, "Rounds");
     const allData = getUserAllData(userId);
      console.log("all data from store for student resource",dataFromStore,allData);
    },[])
const loadMetadata = async () => {
  const metadata = await roundsService.getMetadata();
  const metaFields = metadata[0].fieldValues||[];

  setFields(metaFields);
  // FOREIGNS
  for (let field of metaFields) {
    if (field.foreign) {
      const foreignName = field.foreign;

      if (!fetchedForeign.has(foreignName)) {
        const updated = new Set(fetchedForeign);
        updated.add(foreignName);
        setFetchedForeign(updated);

        const data = await roundsService.getForeignResource(foreignName);

        setForeignKeyData((prev:any) => ({
          ...prev,
          [foreignName]: data,
        }));
      }
    }
  }

  // ENUMS
  for (let field of metaFields) {
    if (field.isEnum) {
      const enumName = field.possible_value;

      if (!fetchedEnum.has(enumName)) {
        const updatedEnum = new Set(fetchedEnum);
        updatedEnum.add(enumName);
        setFetchedEnum(updatedEnum);

        const values = await roundsService.getEnum(enumName);

        setEnums((prev:any) => ({
          ...prev,
          [enumName]: values,
        }));
      }
    }
  }
};

 const save = async (customData?: any) => {
  const finalData = customData || dataToSave;

  const params = new FormData();

  // 👇 ALWAYS use finalData
  let selectedFile = Object.keys(finalData).filter(
    (key) => finalData[key] instanceof File
  );

  // clone to avoid mutating state
  const clonedData = { ...finalData };

  if (selectedFile.length > 0) {
    const fileKey = selectedFile[0];
    params.append(fileKey, finalData[fileKey]);
    clonedData[fileKey] = "";

    params.append("description", "Offer Letter Template");
    params.append("appId", "admission-iiitb");
    params.append("dmsRole", "admin");
    params.append("user_id", userId);
    params.append("tags", "offer_letter");
  }

  const jsonString = JSON.stringify(clonedData);
  const base64Encoded = btoa(jsonString);

  if (finalData.id) {
    params.append("action", "MODIFY");
  }

  params.append("resource", base64Encoded);

  const response = await roundsService.create({ params });
  if (response.errCode === -1) {
    throw new Error("Failed to submit")
  }
  if (response.errCode !== -1) {
    addSubmission(userId, "Student", finalData);
    console.log(
      "data initialized in store in create form model",
      getUserAllData(userId)
    );
  }
};
  return {
    fields,
    setFields,
    enums,
    foreignKeyData,
    setForeignKeyData,
    setEnums,
    dataToSave,
    setDataToSave,
    loadMetadata,
    save,
  };
};
